module.exports = __webpack_public_path__ + "img/1579223958.7495ba54.jpg";